export const GET_LIST_CHIDELETE = "GET_LIST_CHIDELETE";
export const GET_LIST_CHIDELETE_SUCCESS = "GET_LIST_CHIDELETE_SUCCESS";
export const GET_LIST_CHIDELETE_FAILURE = "GET_LIST_CHIDELETE_FAILURE";

export const UPDATE_SEARCHTDATA_CHIDELETE = "UPDATE_SEARCHTDATA_CHIDELETE";
